export default function goLink(link) {
    window.open(link, '_blank')
}